<template>
  <a-form layout="vertical" ref="treatFormRef" :model="retreatFormState" class="retreatForm">
    <a-form-item
      label="复诊日期"
      name="reserveDate"
      :rules="{ required: !isCancel, message: '请选择复诊日期' }"
    >
      <a-date-picker
        v-model:value="retreatFormState.reserveDate"
        style="width: 100%"
        placeholder="请选择"
        @change="formChange"
        :disabled-date="disabledDate"
        :showToday="false"
      >
        <template #dateRender="{ current }">
          <div
            :class="[
              'ant-calendar-date',
              calendarCustomStyle(current)
              // !prop.isBatch
              //   ? appointList.includes(moment(current).format('YYYY-MM-DD'))
              //     ? current > moment()
              //       ? 'calendar-custom'
              //       : 'calendar-custom-passed'
              //     : ''
              //   : ''
            ]"
          >
            {{ current.date() }}
          </div>
        </template>
      </a-date-picker>
    </a-form-item>
    <a-form-item
      label="复诊时段"
      name="reserveDateDetail"
      :rules="{ required: !isCancel, message: '请选择复诊时段' }"
    >
      <a-radio-group v-model:value="retreatFormState.reserveDateDetail" @change="formChange">
        <a-radio :value="1">上午</a-radio>
        <a-radio :value="2">下午</a-radio>
      </a-radio-group>
    </a-form-item>
    <a-form-item
      label="复诊方式"
      name="revisitType"
      :rules="{ required: !isCancel, message: '请选择复诊方式' }"
    >
      <a-radio-group v-model:value="retreatFormState.revisitType" @change="formChange">
        <a-radio :value="1">线上问诊</a-radio>
        <a-radio :value="2">门诊就诊</a-radio>
      </a-radio-group>
    </a-form-item>
    <div class="notreat">
      <a-checkbox v-model:checked="isCancel" @change="hanldeCheck">遵医嘱复诊</a-checkbox>
    </div>
    <div style="margin-top: 20px">
      <a-form-item label="备注">
        <a-textarea
          v-model:value="retreatFormState.remark"
          :maxlength="50"
          :showCount="true"
          placeholder="请输入修改原因～"
          :rows="4"
        />
      </a-form-item>
    </div>
  </a-form>
</template>

<script setup>
import moment from 'moment'
import { ref, defineExpose, reactive, onMounted, computed, defineProps } from 'vue'
import {
  //apiReverseDateList,
  queryCureReserveTag
} from '@/api/workPlace/retreatment.js'
import { useStore } from 'vuex'
const prop = defineProps({
  itemInfo: {
    type: Object,
    default: () => {}
  },
  isBatch: {
    type: Boolean,
    default: false
  }
})
const store = useStore()
const curOrder = computed(() => store.state.workOrder.workOrderGroupInfo)
// 复诊日程日期数据
const appointList = ref([])
const treatFormRef = ref()
const retreatFormState = reactive({
  reserveDate: '',
  reserveDateDetail: '',
  revisitType: '',
  remark: ''
})
const isCancel = ref(false)

const disabledDate = current => {
  // 根据后端返的时间进行限制
  return current && current < moment(prop.itemInfo.limitTime)
}
const calendarCustomStyle = computed(() => {
  return function (current) {
    let className = null
    if (prop.isBatch) {
      className = ''
    } else {
      const curD = moment(current).format('YYYY-MM-DD')
      const date = appointList.value.find(f => f.reserveDate === curD)
      if (date) {
        className = date.reserveTag === 1 ? 'calendar-custom' : 'calendar-custom-passed'
      }
    }
    return className
  }
})
// 联动复诊信息
const hanldeCheck = () => {
  if (isCancel.value) {
    retreatFormState.reserveDate = ''
    retreatFormState.reserveDateDetail = ''
    retreatFormState.revisitType = ''
  }
}
// 清空无需复诊
const formChange = () => {
  if (isCancel.value) {
    isCancel.value = false
  }
}

onMounted(() => {
  // 如果不是批量就获取复诊日程日期
  if (!prop.isBatch) {
    fetchReverseList()
  } else {
    appointList.value = []
  }
})

// 获取复诊日期
const fetchReverseList = () => {
  appointList.value = []
  // apiReverseDateList({
  //   ucDoctorId: curOrder.value.doctorInfo?.ucUserId || null,
  //   ucPatientId: prop.itemInfo.ucPatientId || null
  // }).then(res => {
  //   appointList.value = res
  // })
  const params = {
    ucPatientId: prop.itemInfo.ucPatientId,
    reserveDateMin: null,
    reserveDateMax: null,
    ucDoctorId: curOrder.value.doctorInfo?.ucUserId,
    prescribe: false
  }
  queryCureReserveTag(params).then(result => {
    // console.log('打印标签')
    // console.log(result)
    // reserveTag 复诊标签：1-高亮 2-置灰， reserveDate
    appointList.value = result
  })
}
// 提交表单
const submitValidQuery = () => {
  return new Promise((resolve, reject) => {
    treatFormRef.value
      .validate()
      .then(() => {
        const result = {
          ...retreatFormState,
          reserveDate: retreatFormState.reserveDate
            ? moment(retreatFormState.reserveDate).format('YYYY-MM-DD 00:00:00')
            : '',
          isCancel: isCancel.value
        }
        resolve(result)
      })
      .catch(err => {
        console.log('err', err)
        reject(err)
      })
  })
}

const resetFields = () => {
  treatFormRef.value.resetFields()
}

defineExpose({
  submitValidQuery,
  resetFields
})
</script>

<style lang="scss" scoped>
// .retreatForm {
//   border-bottom: 1px solid #f0f0f0;
// }
.notreat {
  border-top: 1px solid #f0f0f0;
  padding-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.calendar-custom,
.calendar-custom-passed {
  border: 1px dashed #e3e3e3;
  border-radius: 50%;
}
.ant-calendar-date {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 2px;
}

.ant-calendar {
  width: auto;
}

.calendar-custom::after {
  content: '复';
  width: 16px;
  height: 16px;
  background: #2ed1b5;
  border-radius: 4px;
  position: absolute;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  top: -8px;
  right: -5px;
  font-size: 10px;
}
.calendar-custom-passed::after {
  content: '复';
  width: 16px;
  height: 16px;
  background: #f0f0f0;
  border-radius: 4px;
  position: absolute;
  color: #999999;
  display: flex;
  align-items: center;
  justify-content: center;
  top: -8px;
  right: -5px;
  font-size: 10px;
}

.ant-calendar-disabled-cell.ant-calendar-today .ant-calendar-date::before {
  width: 30px !important;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
}

.ant-calendar-disabled-cell.ant-calendar-selected-day .ant-calendar-date::before {
  width: 30px !important;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
}
</style>
